import { useEffect, useState } from "react";
import { IconDots } from "@tabler/icons-react";
import { FileType } from "../../../types/File";
import { FILE_PATH } from "../../../const/enviroment";
import { DEFAULT_FILE_URL } from "../../../fetch/const.routes.ts";
const Icon = ({ src, size }: { src: FileType | string; size: number }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const boxSize = `${size / 4}rem`;
  const boxStyle = { width: boxSize, height: boxSize } as const;

  const cSrc =
    typeof src === "string"
      ? src
      : `${DEFAULT_FILE_URL}/${FILE_PATH}${src.basename}.${src.ext}`;

  useEffect(() => {
    setLoaded(false);
    setFailed(false);
    const img = new Image();
    img.decoding = "async";
    img.loading = "eager";
    img.onload = () => setLoaded(true);
    img.onerror = () => setFailed(true);
    img.src = cSrc;
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [cSrc]);

  if (failed) {
    return <IconDots />;
  }

  return (
    <span
      aria-hidden="true"
      className="relative inline-block align-middle"
      style={boxStyle}
    >
      {!loaded && (
        <span className="absolute inset-0 flex items-center justify-center">
          <IconDots />
        </span>
      )}
      <span
        className="absolute inset-0"
        style={{
          ...boxStyle,
          backgroundColor: "currentColor",
          WebkitMaskImage: `url("${cSrc}")`,
          maskImage: `url("${cSrc}")`,
          maskMode: "alpha",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
          WebkitMaskSize: "contain",
          maskSize: "contain",
          opacity: loaded ? 1 : 0,
        }}
      />
    </span>
  );
};

export default Icon;
